import { render, staticRenderFns } from "./FreeformRequisites.vue?vue&type=template&id=82646c3e&"
import script from "./FreeformRequisites.vue?vue&type=script&lang=js&"
export * from "./FreeformRequisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports